const namespaced = true

const state = {
    sub_area_data: '',
    loading_sub_area: false,
}
const mutations = {
    SET_SUB_AREA(state, data) {
        state.sub_area_data = data;
    },
    SET_LOADING_SUB_AREA(state, data) {
        state.loading_sub_area = data;
    },
}
const actions = {
    setSubAreaSelect(context, data) {
        context.commit('SET_SUB_AREA', data)
    },
}
const getters = {
    getSubAreaLines(state) {
        return state.sub_area_data.production_lines;
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}